import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories, MAIN_SITE_URL } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-layout-grid-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold tracking-tight">{t("brand")}</span>
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#top" className="cursor-pointer hover:text-background-200 transition-colors">
                {t("footer.quickLinks")}
              </a>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 hover:text-background-100 transition-colors">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link to="/basetao-legit" className="text-background-300 hover:text-background-100 transition-colors">
                  {t("nav.readGuide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-300 hover:text-background-100 transition-colors"
                >
                  {t("button.visitMain")}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50">
              <a href="#categories" className="cursor-pointer hover:text-background-200 transition-colors">
                {t("footer.categories")}
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.key}>
                  <a
                    href={c.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-background-300 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {t(`cat.${c.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-100/10">
          <p className="text-xs text-background-400 leading-relaxed max-w-3xl">{t("footer.disclaimer")}</p>
          <p className="mt-4 text-xs text-background-400">
            © {new Date().getFullYear()} {t("brand")}. {t("footer.allRights")}
          </p>
        </div>
      </div>
    </footer>
  );
}